<ng-template #compGrabber let-modal>
    <div class="modal-header">
        <div class="col-12 row">
            <div class="col-4 m-0 p-0 align-space">
                <h3>Available Components</h3>
                <mat-slide-toggle ([value])="showActive" (change)="showActive = showActive ? false : true">Show Active?</mat-slide-toggle>
            </div>
            <div class="col-8 m-0 p-0">
                <mat-form-field appearance="outline" class="w-100">
                    <button matPrefix mat-icon-button color="white" (click)="$event.stopPropagation(); compSearch.setValue(''); filterComponents()">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <ng-container>
                        <input tabindex="1" #itemsearch matInput value="" [formControl]="compSearch" class="text-right" autofocus (keyup)="filterComponents()">
                    </ng-container>
                    <span matSuffix>
                        <button #itemSearchButton tabindex="-1" mat-icon-button color="white" (click)="filterComponents()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </span>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="col-12 m-0 p-0 complist">
            <ng-container *ngFor="let comp of availableComponentsFiltered">
                <div class="row" *ngIf="showActive && isActive(comp) || !showActive && !isActive(comp)">
                    <div class="col-10 m-0 p-0">
                        <ng-container *ngComponentOutlet="comp['component']; injector: comp['injector']"></ng-container>
                    </div>
                    <div class="col-2 m-0 p-0 addsquare p-4">
                        <button class="addbtn" mat-raised-button (click)="addComponent(comp)" *ngIf="!isActive(comp)">Add</button>
                        <button class="removebtn" mat-raised-button (click)="remove(comp)" *ngIf="isActive(comp)">Remove</button>
                    </div>
                </div>
            </ng-container>
        </div>

    </div>
    <div class="modal-footer">
    </div>
</ng-template>


<div class="row w-100 m-0 p-0 mt-2">
    <div class="col-3 mt-0 p-0 ">
        <button mat-raised-button (click)="reset()" class="ml-2 float-left btn-danger">Reset</button>
        <button mat-raised-button (click)="openComponentGrabber()" class="ml-1 float-left">Add Component</button>
    </div>
    <div class="col-6 m-0 p-0">
        <div cdkDropList [id]="'cdk-drop-list-blank'" class="blank-component" #blankList="cdkDropList" [cdkDropListConnectedTo]="activeDrops" (mouseenter)="moreInfo = true" (mouseleave)="moreInfo = false" >
            <div (cdkDragDropped)="addBlank($event)" [cdkDragData]="0" cdkDrag> 
                <ng-container *ngIf="!moreInfo">Blank Spacer</ng-container>
                <ng-container *ngIf="moreInfo">Drag to add a blank spacer</ng-container>
            </div>
            <div *cdkDragPreview class="preview">
            </div>
            <div class="placeholder" *cdkDragPlaceholder>
            </div>
        </div>
    </div>
    <div class="col-3 m-0 p-0">
        <button mat-raised-button (click)="saveDashboard()" class="float-right mr-2" color="primary">Save Dashboard</button>
    </div>
</div>

<small class="italics float-right mr-2 font-weight-lighter">**Double click components for sizing**</small>
<div class="col-12 m-0 p-0 row editor-window" *ngIf="activeComponents.length">

    <div cdkDropListGroup class="col-12 m-0 p-0 row" *ngIf="activeDrops.length">    
        <div cdkDropList  [id]="'cdk-drop-list-' + (i+1)" class="col-lg-{{comp['cardsize']}} col-md-{{comp['cardsize']}} col-sm-{{comp['cardsize']}}" *ngFor="let comp of activeComponents;  let i = index;" cdkDropListOrientation="mixed" [cdkDropListData]="i"  (dblclick)="toggleControls(i)" [ngClass]="{'align-end': !comp.component, 'align-center': comp.name.toLowerCase().includes('blank'), 'border-active p-3': comp.showcontrols || comp.dragging, 'border-notactive' : !comp.showcontrols}" [cdkDropListConnectedTo]="blankList">
            <div [cdkDragData]="i" (cdkDragDropped)="repostion($event)" cdkDragPreviewContainer="parent" [ngClass]="comp['name'].toLowerCase().includes('blank') ? 'w-100 m-0 p-0 border-blank' : 'w-100 m-0 p-0'" (cdkDragStarted)="comp.dragging = true" (cdkDragReleased)="comp.dragging=false" cdkDrag>
                <ng-container *ngIf="comp['component']">
                    <div class="w-100 mb-1" *ngIf="comp['showcontrols']">
                        <div class="w-25 float-right"><button class="abs-upper-right" matTooltip="move to top" (click)="moveComp(comp, 'top')" mat-fab><mat-icon>north</mat-icon></button></div>
                        <div class="w-25 float-right"><button class="abs-lower-right" matTooltip="move to bottom" (click)="moveComp(comp, 'bottom')" mat-fab><mat-icon>south</mat-icon></button></div>
                        <br/>
                    </div>
                    <div *cdkDragPreview class="preview">

                        <ng-container *ngComponentOutlet="comp['component']; injector: comp['injector']"></ng-container>
                    </div>
                    <div class="placeholder" *cdkDragPlaceholder></div>
                    <ng-container *ngIf="comp['name'].toLowerCase().includes('blank')">
                        <div class="italics pos-abs font-weight-lighter">Spacer</div>
                    </ng-container>
                    <div [ngClass]="{'pl-5 pr-5': comp['showcontrols']}">
                        <ng-container *ngComponentOutlet="comp['component']; injector: comp['injector']"></ng-container>
                    </div>
                </ng-container>
                
                <div class="component-controls pl-1 pr-1" *ngIf="comp['showcontrols']">
                    <button mat-raised-button (click)="remove(comp)" class="float-left btn-danger"><mat-icon>delete</mat-icon></button>
                    <mat-radio-group aria-label="Select a width" class="float-right" [value]="comp['cardsize']" (change)="changeSize(comp, $event)">
                        <mat-radio-button class="m-1" value="3">3</mat-radio-button>
                        <mat-radio-button class="m-1" value="4">4</mat-radio-button>
                        <mat-radio-button class="m-1" value="6">6</mat-radio-button>
                        <mat-radio-button class="m-1" value="8">8</mat-radio-button>
                        <mat-radio-button class="m-1" value="12">12</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="w-100 mt-3" *ngIf="comp['showcontrols']">
                    <br/>
                </div>
            </div>
        </div>
    </div>
</div>